import { GET_TPP_SETTINGS_SUCCESS, GET_EMAIL_TEMPLATES_SUCCESS } from 'Constants/settingConstants';
import RestClient from 'Services/RestClientService';
import { normalizeApiResponse } from 'Utils/ApiResponseHelper';
import logger from 'Services/MyTuiProfileCustomLogger';

export function getTppSettings() {
  function getTppSettingsSuccess(settings) {
    return {
      type: GET_TPP_SETTINGS_SUCCESS,
      data: { settings },
    };
  }

  return async function (dispatch) {
    try {
      const response = await RestClient.Get('setting/setting');
      const settingsData = normalizeApiResponse(response) || {};
      dispatch(getTppSettingsSuccess(settingsData));
    } catch (error) {
      logger.error('Error fetching TPP settings:', error);
    }
  };
}

export function getEmailTemplates() {
  const getEmailTemplatesSuccess = (emailTemplates) => {
    return {
      type: GET_EMAIL_TEMPLATES_SUCCESS,
      data: { emailTemplates },
    };
  };

  return async function (dispatch) {
    try {
      const response = await RestClient.Get('setting/mail-template');
      const emailTemplatesData = normalizeApiResponse(response) || [];
      dispatch(getEmailTemplatesSuccess(emailTemplatesData));
    } catch (error) {
      logger.error('Error fetching email templates:', error);
    }
  };
}
